export default __webpack_public_path__ + "static/media/up.b1e96f94.svg";